import { ViewColumn as ViewColumnIcon, ViewList as ViewListIcon } from '@mui/icons-material';
import { ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';

export type LayoutMode = 'module' | 'patient';

interface LayoutToggleProps {
  value: LayoutMode;
  onChange: (mode: LayoutMode) => void;
}

export function LayoutToggle({ value, onChange }: LayoutToggleProps) {
  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={(_e, next: LayoutMode | null) => {
        if (next) onChange(next);
      }}
      size="small"
      aria-label="Layout mode"
    >
      <ToggleButton value="module" aria-label="By Module">
        <Tooltip title="By Module">
          <ViewListIcon fontSize="small" />
        </Tooltip>
      </ToggleButton>
      <ToggleButton value="patient" aria-label="By Patient">
        <Tooltip title="By Patient">
          <ViewColumnIcon fontSize="small" />
        </Tooltip>
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
